import { useAsync } from "./useAsync";
import * as api from "../lib/api";

/** Fetch add-on buyers for the admin panel. */
export function useAdminAddOnRequests() {
  return useAsync(() => api.getAdminAddOnRequests(), []);
}

/** Fetch newsletter subscribers for the admin panel. */
export function useAdminNewsletterSubscribers() {
  return useAsync(() => api.getAdminNewsletterSubscribers(), []);
}

/** Fetch contact form submissions for the admin panel. */
export function useAdminContactSubmissions() {
  return useAsync(() => api.getAdminContactSubmissions(), []);
}
